class ChartJs {
    /**
     * @desc get chart values from dom list
     * @param chartValues
     * @param percentageCalc
     * @returns {[*[],*[],*[]]}
     */
    getChartValues = (chartValues, percentageCalc = 'true') => {
        const labels = [],
            values = [],
            barcolors = [];

        let sum = this.getValueSum(chartValues),
            percentage;

        Array.from(chartValues).forEach(value => {
            labels.push(value.dataset.label);
            barcolors.push(value.dataset.color);

            if(percentageCalc === 'true') {
                percentage = this.getPercentage(parseInt(value.dataset.value), sum);
            } else {
                percentage = parseInt(value.dataset.value);
            }

            values.push(percentage);
        })

        return [labels, values, barcolors];
    }

    /**
     * @desc get percentage value
     * @param value
     * @param sum
     * @returns {number}
     */
    getPercentage = (value, sum) => {
        return Math.round((value / sum) * 100);
    }

    /**
     * @desc get sum of used value
     * @param chartValues
     * @returns {number}
     */
    getValueSum = (chartValues) => {
        let sum = 0;

        Array.from(chartValues).forEach(value => {
            sum += parseInt(value.dataset.value);
        })

        return sum;
    }

    /**
     * @desc Get percentage value from given values for datalabels
     * @param value
     * @param ctx
     * @param axisUnit
     * @returns {string|*}
     */
    datalabelsFormatter = (value, ctx, axisUnit = null) => {
        let datasets = ctx.chart.data.datasets;

        if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
            if(axisUnit === "" || axisUnit === null || axisUnit === " ") {
                return value;
            } else {
                return value + " " + axisUnit;
            }
        } else {
            return value;
        }
    }

    /**
     * @desc Get percentage value from given values for tooltip
     * @param value
     * @param axisUnit
     * @returns {string|*}
     */
    tooltipFormatter = (value, axisUnit = null) => {

        if(axisUnit === "" || axisUnit === null || axisUnit === " ") {
            return value.raw;
        } else {
            return value.raw + " " + axisUnit;
        }
    }

    /**
     * @desc show additional tooltip
     * @param chart
     * @param additionalTooltip
     * @returns {string}
     */
    showAdditionalTooltip = (chart, additionalTooltip) => {
        let tooltipElements = additionalTooltip.querySelectorAll('.tooltip-item');

        tooltipElements.forEach(tooltip => {
            tooltip.classList.add('hide')
        })

        tooltipElements[chart[0].dataIndex].classList.remove('hide');

        return '';
    }
}
